import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "flex flex-row gap-4" }
const _hoisted_2 = {
  key: 0,
  class: "flex flex-row justify-center items-center gap-2"
}
const _hoisted_3 = {
  key: 0,
  class: "w-28 mr-5"
}
const _hoisted_4 = {
  key: 1,
  class: "w-28"
}
const _hoisted_5 = { class: "flex flex-col" }
const _hoisted_6 = { class: "flex-grow text-16px text-gray-lp-300" }
const _hoisted_7 = { class: "text-12px xxl:text-14px" }
const _hoisted_8 = { class: "font-semibold" }
const _hoisted_9 = { class: "font-semibold" }
const _hoisted_10 = { style: {"width":"118px"} }
const _hoisted_11 = { class: "text-sm mb-2" }
const _hoisted_12 = {
  key: 0,
  class: "flex flex-row justify-center items-center gap-2"
}
const _hoisted_13 = {
  key: 0,
  class: "w-28 mr-5"
}
const _hoisted_14 = {
  key: 1,
  class: "w-28"
}
const _hoisted_15 = { class: "flex flex-col" }
const _hoisted_16 = { class: "flex-grow text-16px text-gray-lp-300" }
const _hoisted_17 = { class: "text-12px xxl:text-14px" }
const _hoisted_18 = { class: "font-semibold" }
const _hoisted_19 = { class: "font-semibold" }
const _hoisted_20 = { style: {"width":"118px"} }
const _hoisted_21 = { class: "text-sm mb-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Title = _resolveComponent("Title")!
  const _component_button_fill = _resolveComponent("button-fill")!
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_Card = _resolveComponent("Card")!
  const _component_BankModal = _resolveComponent("BankModal")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock("section", null, [
    _createVNode(_component_Title, {
      class: "mb-4",
      label: _ctx.$t('clientManagement.managementDetail.bankInfoTitle'),
      hint: _ctx.$t('clientManagement.registrationForm.bank.optionalHint')
    }, null, 8, ["label", "hint"]),
    _createVNode("div", _hoisted_1, [
      _createVNode(_component_Card, {
        rounded: "md",
        class: ["flex-1  px-6 py-3", {
          'flex justify-center': !!_ctx.bankDetail.accountName && !_ctx.isAddBank
        }],
        fontSize: 14
      }, {
        default: _withCtx(() => [
          (!!_ctx.bankDetail.accountName && !_ctx.isAddBank)
            ? (_openBlock(), _createBlock("div", _hoisted_2, [
                (!!_ctx.bankDetail.bankName && _ctx.isShowBankLogo)
                  ? (_openBlock(), _createBlock("div", _hoisted_3, [
                      _createVNode("img", {
                        src: 
                require(`@/app/ui/assets/images/${_ctx.bankDetail.bankName}.png`)
              ,
                        class: "w-28",
                        alt: ""
                      }, null, 8, ["src"])
                    ]))
                  : (_openBlock(), _createBlock("div", _hoisted_4)),
                _createVNode("div", _hoisted_5, [
                  _createVNode("div", _hoisted_6, [
                    _createVNode("p", _hoisted_7, _toDisplayString(_ctx.bankDetail.bankLabel), 1),
                    _createVNode("p", _hoisted_8, _toDisplayString(_ctx.bankDetail.accountNo), 1),
                    _createVNode("p", null, [
                      _createTextVNode(_toDisplayString(_ctx.$t("clientManagement.managementDetail.accountNameAbbr")) + " ", 1),
                      _createVNode("span", _hoisted_9, _toDisplayString(_ctx.bankDetail.accountName), 1)
                    ]),
                    _createVNode("p", null, _toDisplayString(_ctx.bankDetail.email), 1)
                  ])
                ]),
                _createVNode("div", _hoisted_10, [
                  (_ctx.isAbleToAdjustBank)
                    ? (_openBlock(), _createBlock(_component_button_fill, {
                        key: 0,
                        title: _ctx.$t('clientManagement.registrationForm.bank.delete'),
                        icon: "delete",
                        "font-bold": "",
                        class: "text-red-lp-300 px-8",
                        style: {"background-color":"white"},
                        onClick: _cache[1] || (_cache[1] = () => _ctx.onConfirmDelete(true))
                      }, null, 8, ["title"]))
                    : _createCommentVNode("", true)
                ])
              ]))
            : (_openBlock(), _createBlock(_component_DataWrapper, {
                key: 1,
                label: _ctx.$t('clientManagement.registrationForm.bank.bankAccountInfo')
              }, {
                default: _withCtx(() => [
                  _createVNode("p", _hoisted_11, _toDisplayString(_ctx.$t("clientManagement.registrationForm.bank.noBankAccountSaved")), 1),
                  (_ctx.isAbleToAdjustBank)
                    ? (_openBlock(), _createBlock(_component_LpButton, {
                        key: 0,
                        outline: "",
                        title: _ctx.$t('clientManagement.registrationForm.bank.addBankAccount'),
                        textColor: "red-lp-100 font-semibold",
                        onClick: _ctx.onAddBank
                      }, null, 8, ["title", "onClick"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["label"]))
        ]),
        _: 1
      }, 8, ["class"]),
      _createVNode(_component_Card, {
        rounded: "md",
        class: ["flex-1 px-6 py-3", {
          'flex justify-center': !!_ctx.settlementDetail.accountName && !_ctx.isAddSettlement
        }],
        fontSize: 14
      }, {
        default: _withCtx(() => [
          (!!_ctx.settlementDetail.accountName && !_ctx.isAddSettlement)
            ? (_openBlock(), _createBlock("div", _hoisted_12, [
                (!!_ctx.settlementDetail.bankName && _ctx.isShowSettlemenBankLogo)
                  ? (_openBlock(), _createBlock("div", _hoisted_13, [
                      _createVNode("img", {
                        src: 
                require(`@/app/ui/assets/images/${_ctx.settlementDetail.bankName}.png`)
              ,
                        class: "w-28",
                        alt: ""
                      }, null, 8, ["src"])
                    ]))
                  : (_openBlock(), _createBlock("div", _hoisted_14)),
                _createVNode("div", _hoisted_15, [
                  _createVNode("div", _hoisted_16, [
                    _createVNode("p", _hoisted_17, _toDisplayString(_ctx.settlementDetail.bankLabel), 1),
                    _createVNode("p", _hoisted_18, _toDisplayString(_ctx.settlementDetail.accountNo), 1),
                    _createVNode("p", null, [
                      _createTextVNode(_toDisplayString(_ctx.$t("clientManagement.managementDetail.accountNameAbbr")) + " ", 1),
                      _createVNode("span", _hoisted_19, _toDisplayString(_ctx.settlementDetail.accountName), 1)
                    ]),
                    _createVNode("p", null, _toDisplayString(_ctx.settlementDetail.email), 1)
                  ])
                ]),
                _createVNode("div", _hoisted_20, [
                  (_ctx.isAbleToAdjustBank)
                    ? (_openBlock(), _createBlock(_component_button_fill, {
                        key: 0,
                        title: _ctx.$t('clientManagement.registrationForm.bank.delete'),
                        icon: "delete",
                        "font-bold": "",
                        class: "text-red-lp-300 px-8",
                        style: {"background-color":"white"},
                        onClick: _cache[2] || (_cache[2] = () => _ctx.onConfirmDeleteSettlement(true))
                      }, null, 8, ["title"]))
                    : _createCommentVNode("", true)
                ])
              ]))
            : (_openBlock(), _createBlock(_component_DataWrapper, {
                key: 1,
                label: _ctx.$t('clientManagement.managementDetail.bankSettlementInfoTitle')
              }, {
                default: _withCtx(() => [
                  _createVNode("p", _hoisted_21, _toDisplayString(_ctx.$t("clientManagement.registrationForm.bank.noBankAccountSaved")), 1),
                  (_ctx.isAbleToAdjustBank)
                    ? (_openBlock(), _createBlock(_component_LpButton, {
                        key: 0,
                        outline: "",
                        title: _ctx.$t('clientManagement.registrationForm.bank.addBankAccount'),
                        textColor: "red-lp-100 font-semibold",
                        onClick: _ctx.onAddSettlement
                      }, null, 8, ["title", "onClick"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["label"]))
        ]),
        _: 1
      }, 8, ["class"])
    ]),
    (_ctx.isAddBank)
      ? (_openBlock(), _createBlock(_component_BankModal, {
          key: 0,
          type: "bank"
        }))
      : _createCommentVNode("", true),
    (_ctx.isAddSettlement)
      ? (_openBlock(), _createBlock(_component_BankModal, {
          key: 1,
          type: "settlement"
        }))
      : _createCommentVNode("", true),
    (_ctx.isDelete)
      ? (_openBlock(), _createBlock(_component_Modal, {
          key: 2,
          onSubmit: _ctx.onDeleteBank,
          onClose: () => _ctx.onConfirmDelete(false),
          title: _ctx.$t('clientManagement.registrationForm.bank.deleteConfirmationTitle'),
          message: _ctx.$t('clientManagement.registrationForm.bank.deleteConfirmationMessage'),
          image: "are-you-sure",
          textSuccess: _ctx.$t('clientManagement.registrationForm.bank.delete'),
          textCancel: _ctx.$t('clientManagement.infoPriceClient.back'),
          class: "px-8"
        }, null, 8, ["onSubmit", "onClose", "title", "message", "textSuccess", "textCancel"]))
      : _createCommentVNode("", true),
    (_ctx.isDeleteSettlement)
      ? (_openBlock(), _createBlock(_component_Modal, {
          key: 3,
          onSubmit: _ctx.onDeleteSettlement,
          onClose: () => _ctx.onConfirmDeleteSettlement(false),
          title: _ctx.$t('clientManagement.registrationForm.bank.deleteConfirmationTitle'),
          message: _ctx.$t('clientManagement.registrationForm.bank.deleteConfirmationMessage'),
          image: "are-you-sure",
          textSuccess: _ctx.$t('clientManagement.registrationForm.bank.delete'),
          textCancel: _ctx.$t('clientManagement.infoPriceClient.back'),
          class: "px-8"
        }, null, 8, ["onSubmit", "onClose", "title", "message", "textSuccess", "textCancel"]))
      : _createCommentVNode("", true)
  ]))
}